import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between" }
const _hoisted_2 = { class: "flex items-center gap-4" }
const _hoisted_3 = { class: "flex flex-wrap gap-2" }
const _hoisted_4 = { class: "flex-1 flex overflow-hidden relative min-h-0" }
const _hoisted_5 = { class: "flex-1 relative bg-slate-100/50 dark:bg-background" }
const _hoisted_6 = { class: "absolute inset-0" }
const _hoisted_7 = { class: "w-[500px] shrink-0 border-l bg-muted flex flex-col overflow-hidden" }
const _hoisted_8 = { class: "flex-1 flex flex-col border-b bg-background overflow-hidden relative" }
const _hoisted_9 = { class: "flex-1 flex flex-col bg-background overflow-hidden relative" }

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Copy, Check, Code2 } from 'lucide-vue-next'
import { ref, watch } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseVisualEditor',
  props: {
    open: { type: Boolean },
    title: {},
    description: {},
    showCode: { type: Boolean },
    copied: { type: Boolean }
  },
  emits: ["update:open", "update:showCode", "copy", "save"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const handleCopy = () => {
  emit('copy')
}

const isEditingMode = ref(false)

watch(() => props.open, (val) => {
  if (val) {
    isEditingMode.value = !!localStorage.getItem('editingDiagramCode')
  } else {
    isEditingMode.value = false
  }
}, { immediate: true })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    open: __props.open,
    "onUpdate:open": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:open', $event)))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DialogContent), { class: "!max-w-[100vw] !w-screen !h-screen !m-0 !p-0 !rounded-none !border-none flex flex-col bg-background" }, {
        default: _withCtx(() => [
          _createVNode(_unref(DialogHeader), { class: "shrink-0 p-4 pb-2 border-b bg-muted/20" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", null, [
                  _createVNode(_unref(DialogTitle), { class: "text-xl flex items-center gap-2" }, {
                    default: _withCtx(() => [
                      _renderSlot(_ctx.$slots, "icon"),
                      _createTextVNode(" " + _toDisplayString(__props.title), 1)
                    ]),
                    _: 3
                  }),
                  _createVNode(_unref(DialogDescription), { class: "mt-1" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.description), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _renderSlot(_ctx.$slots, "toolbar")
                  ]),
                  _cache[5] || (_cache[5] = _createElementVNode("div", { class: "h-6 w-px bg-border mx-2" }, null, -1)),
                  _createVNode(_unref(Button), {
                    variant: "outline",
                    size: "sm",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:showCode', !__props.showCode))),
                    class: _normalizeClass(__props.showCode ? 'bg-primary/10' : '')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Code2), { class: "w-4 h-4 mr-2" }),
                      _createTextVNode(" " + _toDisplayString(__props.showCode ? 'Ocultar Panel de Código' : 'Mostrar Panel de Código'), 1)
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_unref(Button), {
                    variant: "outline",
                    size: "sm",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:open', false)))
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode("Cancelar", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_unref(Button), {
                    size: "sm",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('save')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(isEditingMode.value ? 'Actualizar Diagrama' : 'Insertar en Documento'), 1)
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 3
          }),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _renderSlot(_ctx.$slots, "canvas")
              ])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _renderSlot(_ctx.$slots, "code-panel")
              ]),
              _createElementVNode("div", _hoisted_9, [
                _renderSlot(_ctx.$slots, "live-preview")
              ])
            ], 512), [
              [_vShow, __props.showCode]
            ])
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["open"]))
}
}

})